<template>
  <div>
    <div class="row text-left">
      <div class="col-12 col-lg-12">
        <h6 class="tituloH6 color-trabalho">Pronto! Agora é só fazer o download</h6>
        <!-- <p class="caption1 color-gray-400 mb-40">Escolha o formato (PDF ou DOCX) e baixe seu currículo.</p> -->
        <p class="caption1 color-gray-400 mb-40">Escolha o formato (PDF ou DOCX) e baixe seu currículo.</p>
        <div class="input-label download-box">
          <label class="caption1 color-secondary-600 bold mb-0">Selecione o formato que deseja exportar:</label>
          <div class="d-flex flex-column flex-xl-row align-items-xl-center align-items-end">
            <select-component classNames="select-size-too-big-100" secondClassNames="mw-xxl-100" id="idioma" valueKey="nome" placeholder="Selecione uma opção" :value.sync="valueInternal.optionDownload" :valuesList="optionDownloadList"></select-component>
          </div>
        </div>
      </div>
    </div>
     <a
            href="javascript:void(0);"
            class="
             botao botao-download-azul botao-pequeno float-right mt-4 curriculo-download
            "
            @click="btnDownload"
            >Baixar</a>
  </div>
  
</template>

<script>
import SelectComponent from './shared/SelectComponent.vue';

export default {
  name: "DownloadInputComponent",
  props: ['value'],
  components: {
    SelectComponent
  },
  computed: {
    valueInternal: {
      get: function () {
        return this.value;
      },
      set: function (value) {
        this.$emit("update:value", value);
      },
    },
  },
  data() {
    return {
      optionDownloadList: [
        {
          id: 1,
          nome: "PDF padrão - Fechado (Recomendado)"
        },
        {
          id: 2,
          nome: "DOCX padrão - Fechado"
        },
      ]
    }
  },
  methods: {
    btnDownload() {
      this.$emit('download');
    }
  },
};
</script>

<style scoped>
</style>
